import { mapState } from 'vuex';

export default {
    name: 'cdvpayments',
    props: {
        plan : Object
    },

    data : function(){

        return {
            loading : false,
            selectedPeriod : null,
            currency : null
        }

    },

    created() {
        this.selectedPeriod = _.min(this.price, (p) => {
            return p.p
        })

        this.currency = this.selectedPeriod.currency

        console.log('this.cdvproductsFilteredAndGroups', this.cdvproductsFilteredAndGroups)
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        cdv : function(){
            return this.core.cordovakit.purchases.available
        },

        cdvproducts : function(state){
            return state.cdvproducts || []
        },

        cdvproductsFilteredAndGroups : function(){
            var p = _.filter(this.cdvproducts, (p) => {
                return p.id.indexOf(this.plan.name) > -1
            })

            return p
        },

        successCDVpayment : state => state.successCDVpayment,

        owned : function(){
            return _.find(this.cdvproductsFilteredAndGroups, (p) => {
                return p.owned
            })
        },

        price : function(){
            return _.map(this.cdvproductsFilteredAndGroups, (cdvproduct) => {
                var priceinfo = cdvproduct.offers[0].pricingPhases[0]

                var currency = priceinfo.currency.toLowerCase()

                var period = priceinfo.billingPeriod == 'P1Y' ? 365 : priceinfo.billingPeriod == 'P1M' ? 31 : 0

                var priceObject = {
                    currency : currency,
                    [currency] : priceinfo.priceMicros / 1000000,
                    p : period,
                    productId : cdvproduct.id,
                    offerId : cdvproduct.offers[0].id
                }

                return priceObject
            })
        }
    }),

    methods : {

        selectPeriod : function(p){
            this.selectedPeriod = p
        },

        buy : function(){
            this.buycdv(this.selectedPeriod.productId, this.selectedPeriod.offerId)
        },

        buycdv : function(productId, offerId){

            this.$store.commit('globalpreloader', true)

            this.core.cordovakit.purchases.buy(productId, offerId).then(() => {

                this.$store.commit('successCDVpayment', true)

                this.$store.commit('icon', {
                    icon : 'success'
                })

                this.$emit('close')

                setTimeout(() => {
                    this.$router.push('/')
                }, 400)

            }).catch(e => {
                if(e != 'cancelled'){
                    this.core.sitemessage(this.$t('plans.cdv.error.' + e))
                }
            }).finally(() => {
                this.$store.commit('globalpreloader', false)
            })
            
        },

        privacy : function(){
            this.core.vueapi.privacy()
        },

        terms : function(){
            this.core.vueapi.terms()
        },

        eula : function(){
            this.core.vueapi.eula()
        }

        
    },
}